// src/home-panel/UpgradePrompt.jsx
// Phase 37 Plan 04 — extracted from src/App.jsx (originally lines 4667–4719).
//
// ONB-03 (D-07) — pure presentation component with two render variants:
//   • inline-banner — plantLimit, unknownPlant, sickPlant
//   • nudge-card    — deviceChange, seasonalNudge
// All side-effects (logEvent on mount) are owned by the sibling
// UpgradePromptHost so this component stays render-only.

import { useEffect } from 'react';
import { ArrowRight, X } from 'lucide-react';
import { CardDismiss } from '../App.jsx';   // tiny atom stays in App.jsx (D-01)

export default function UpgradePrompt({ variant, triggerId, title, body, primaryLabel, metaLabel, icon: Icon, onPrimary, onDismiss }) {
  if (variant === 'nudge-card') {
    return (
      <div role="status" style={{
        padding:'16px 40px 16px 16px', position:'relative', minHeight:72,
        display:'flex', gap:12, alignItems:'flex-start',
        background:'var(--c-bg)', border:'1px solid var(--c-border)', borderRadius:14,
      }}>
        <CardDismiss onDismiss={onDismiss}/>
        <div style={{flexShrink:0, width:34, height:34, borderRadius:10, background:'var(--c-tint)', display:'flex', alignItems:'center', justifyContent:'center'}}>
          {Icon && <Icon size={17} style={{color:'var(--c-heading)'}}/>}
        </div>
        <div style={{flex:1, minWidth:0}}>
          <div style={{fontSize:'var(--font-small)', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.07em', color:'var(--c-heading)', marginBottom:4}}>{metaLabel}</div>
          <div style={{fontSize:'var(--font-body)', fontWeight:400, color:'var(--c-text)', lineHeight:1.5}}>{body}</div>
          <button type="button" onClick={onPrimary} style={{
            marginTop:8, background:'none', border:'1px solid var(--c-border)', borderRadius:14,
            padding:'4px 12px', fontSize:'var(--font-small)', color:'var(--c-text-2)',
            cursor:'pointer', fontFamily:'inherit', fontWeight:600,
          }}>{primaryLabel}<ArrowRight size={12} aria-hidden="true" style={{verticalAlign:'middle', marginLeft:4}}/></button>
        </div>
      </div>
    );
  }
  // inline-banner variant (default)
  return (
    <div role="status" style={{
      background:'var(--c-tint)', border:'1px solid var(--c-border)', borderRadius:12,
      padding:16, marginBottom:16, display:'flex', alignItems:'flex-start',
      justifyContent:'space-between', gap:12, animation:'tendUpgradeBannerIn 200ms ease',
    }}>
      <div style={{flex:1, minWidth:0}}>
        <div style={{fontSize:'var(--font-small)', fontWeight:600, color:'var(--c-heading)', marginBottom:4}}>{title}</div>
        <div style={{fontSize:'var(--font-small)', fontWeight:400, color:'var(--c-text-2)', lineHeight:1.5}}>{body}</div>
        <button type="button" onClick={onPrimary} style={{
          marginTop:8, background:'var(--c-heading)', color:'#fff', border:'none',
          borderRadius:20, padding:'8px 24px', fontSize:'var(--font-body)', fontWeight:600,
          cursor:'pointer', fontFamily:'inherit', minHeight:44,
        }}>{primaryLabel}</button>
      </div>
      <button type="button" onClick={onDismiss} aria-label="Dismiss"
        style={{background:'none', border:'none', cursor:'pointer', color:'var(--c-text-3)', padding:4, flexShrink:0, lineHeight:1}}>
        <X size={14}/>
      </button>
    </div>
  );
}

// UpgradePromptHost — calls onShow once on mount; keeps UpgradePrompt pure (Pitfall 1).
// Co-located here (rather than its own file) because it is a one-line wrapper with
// a single consumer. Exported alongside the default so both ../App.jsx (rendering
// as <UpgradePromptHost ...>) and ../home-panel/HomePanel.jsx (Plan 37-04 Task 2)
// can pick it up via named import.
export function UpgradePromptHost({ onShow, ...rest }) {
  useEffect(() => { if (onShow) onShow(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <UpgradePrompt {...rest}/>;
}
